import React, { useState } from 'react';
import './BadgesGallery.css';
import GoldBadge from '../../assets/gold_badge.svg';
import SilverBadge from '../../assets/silver_badge.svg';
import BronzeBadge from '../../assets/bronze_badge.svg';

const BadgesGallery = ({ badgeData }) => {
	const [showAll, setShowAll] = useState(false);

	const toggleView = () => setShowAll((prev) => !prev);

	// Sort badges by earned date descending
	const sortedBadges = [...badgeData].sort(
		(a, b) => new Date(b.EARNED_DATE) - new Date(a.EARNED_DATE)
	);

	const displayedBadges = showAll ? sortedBadges : sortedBadges.slice(0, 12);

	const getBadgeLabel = (type) => {
		switch (type?.toUpperCase()) {
			case 'GOLD':
				return GoldBadge;
			case 'SILVER':
				return SilverBadge;
			case 'BRONZE':
				return BronzeBadge;
			default:
				return '';
		}
	};

	return (
		<div>
			<div className={`badge-grid ${showAll ? 'expanded' : ''}`}>
				{displayedBadges.map((badge, index) => (
					<div key={index} className="badge-card">
						<div className={`badge-icon badge-${badge.BADGE_TYPE.toLowerCase()}`}>
							<img
								src={getBadgeLabel(badge.BADGE_TYPE)}
								alt={`${badge.BADGE_TYPE} badge`}
								className="badge-image"
							/>
						</div>
						<div className="badge-content">
							<strong>
								{badge.BADGE_TYPE.charAt(0) +
									badge.BADGE_TYPE.slice(1).toLowerCase()}
							</strong>
							<h4>{badge.SUBTOPIC_NAME || badge.TOPIC_NAME}</h4>
							{badge.PROGRESS_PERCENT ? (
								<p>Progress: {badge.PROGRESS_PERCENT} %</p>
							) : (
								<p>
									Earned on:{' '}
									{new Date(badge.EARNED_DATE).toLocaleDateString('en-GB', {
										day: '2-digit',
										month: 'short',
										year: 'numeric',
									})}
								</p>
							)}
						</div>
					</div>
				))}
			</div>

			<button className="view-more-button" onClick={toggleView}>
				{showAll ? 'View Less ▲' : 'View More ▼'}
			</button>
		</div>
	);
};

export default BadgesGallery;
